import React, { useState, useRef } from 'react'
import axios from 'axios';
import ImageWithBasePath from '../../../core/data/img/ImageWithBasePath'
import { Link, useNavigate } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import ReCAPTCHA from 'react-google-recaptcha';

type PasswordField = "password" | "confirmPassword";

const AdminLogin = () => {
  const captchaRef = useRef(null);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    captchaToken: "",
    resMessage: "",
    resType: 0,
  });
  const handleCaptchaChange = (token) => {
    // console.log("Captcha Token:", token);
     setFormData((prevState) => ({
      ...prevState,
      captchaToken: token,
    }));
  };
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,  
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const navigate = useNavigate();
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}admin/login`, formData);
      // Handle success
      const data = response.data;
      // alert(REACT_APP_GOOGLE_SITE_KEY);
      setFormData((prevState) => ({
        ...prevState,
        resType: Number(data.status),
        resMessage: data.message,
      }));
       if (data.status === 1) {
        // success login
        // Store token if needed
        localStorage.setItem('aToken', data.token);
        navigate(all_routes.adminDashboard);
      } else {
        captchaRef.current?.reset(); // 👈 reset captcha on failure
      }
    } catch (error: any) {
      console.error('Login error:', error);
      setFormData((prevState) => ({
        ...prevState,
        resType: 0,
        resMessage: error.message,
      }));
      // alert(error?.response?.data?.message || 'Login failed');
    }
  };
      
  return (
    <div className="main-wrapper">
      <div className="container-fuild">
        <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
          <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
            <div className="col-lg-5 mx-auto">
              <form onSubmit={handleSubmit} className="p-4">
                <div className="mx-auto mb-5 text-center">
                  <ImageWithBasePath src="logo.png" className="img-fluid" alt="Logo" />
                </div>
                <div className="card authentication-card mb-0">
                  <div className="card-body">
                    <div className="login-icon bg-dark d-flex align-items-center justify-content-center mx-auto mb-4">
                      <i className="ti ti-login fs-24" />
                    </div>
                    <div className="text-center mb-3">
                      <h4 className="mb-1">Welcome Back</h4>
                      <p className="mb-0">Please enter your details to sign in</p>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          required
                          type="email"
                          value={formData.email}
                          className="form-control border-end-0"
                          onChange={(e) => {
                            setFormData((prevState) => ({
                              ...prevState,
                              email: e.target.value,
                            }));
                          }}
                        />
                        <span className="input-group-text border-start-0">
                          <i className="ti ti-mail" />
                        </span>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Password <span className="text-danger">*</span>
                      </label>
                      <div className="pass-group">
                        <input
                          required
                          type={passwordVisibility.password ? "text" : "password"}
                          className="pass-input form-control"
                          onChange={(e) => {
                            setFormData((prevState) => ({
                              ...prevState,
                              password: e.target.value,
                            }));
                          }}
                        />
                        <span 
                          className={`ti toggle-password ${
                            passwordVisibility.password
                              ? "ti-eye"
                              : "ti-eye-off"
                          }`}
                          onClick={() => togglePasswordVisibility("password")}
                        />
                      </div>
                    </div>
                    <center>
                      <ReCAPTCHA
                        sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
                        onChange={handleCaptchaChange}
                        ref={captchaRef}
                      />
                    </center>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        {/* <div className="form-check form-check-md mb-0" style={{  }}>
                          <input
                            className="form-check-input"
                            id="remember_me"
                            type="checkbox"
                          />
                          <label
                            htmlFor="remember_me"
                            className="form-check-label mt-0"
                          >
                            Remember Me
                          </label>
                        </div> */}
                      </div>
                      <div className="text-end">
                        <Link
                          to={all_routes.adminForgotPassword}
                          className="link-default text-decoration-underline"
                        >
                          Forgot Password
                        </Link>
                      </div>
                    </div>
                    {formData.resMessage !== "" && (
                      <div className={`mt-3 alert alert-${formData.resType === 1 ? 'success' : 'danger'}`}>
                        {formData.resMessage}
                      </div>  
                    )}
                    <div className="mt-3">
                      <button
                        type="submit"
                        className="btn btn-dark w-100"
                        onClick={() => {
                          setFormData((prevState) => ({
                            ...prevState,
                            resType: 0,
                            resMessage: "",
                          }));
                        }}
                      >
                        Login
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="login-bg">
        <ImageWithBasePath
          src="assets/admin/img/bg/login-bg-01.png"
          alt="img"
          className="login-bg-01"
        />
        <ImageWithBasePath
          src="assets/admin/img/bg/login-bg-02.png"
          alt="img"
          className="login-bg-02"
        />
      </div>
    </div>

  )
}

export default AdminLogin